export default "__VITE_ASSET__9c97ab4f__"